import React from 'react'
import { useMutation } from '@apollo/client'
import { Merchant } from '@slerp/controls'
import { StripeConnect } from '../Utils/Stripe'
import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import { DISCONNECT_STRIPE_SETTINGS } from './actions'
import { useStripeDisconnect } from 'components/Common'

const StripeConnectSettings = (props: { merchant: Merchant }) => {
  const { stripeConnectData, refetchStripeConnectData } = useMerchant()
  const { merchant } = props

  const [disconnectStripeSettings] = useMutation(DISCONNECT_STRIPE_SETTINGS, {
    fetchPolicy: 'no-cache'
  })

  const { modals, openConfirm, disconnecting } = useStripeDisconnect({
    disconnect: () =>
      disconnectStripeSettings({ variables: { merchantId: merchant?.id } }),
    onSuccess: refetchStripeConnectData,
    invoicesPath: '/settings/accounts-and-billing/invoices'
  })

  return (
    <>
      <StripeConnect
        stripeId={merchant?.stripe_settings?.[0]?.stripe_user_id}
        hasStripeCustomerId={!!merchant?.subscription?.stripe_customer_id}
        stripeConnectUrl={stripeConnectData}
        onDisconnect={openConfirm}
        disconnecting={disconnecting}
      />
      {modals}
    </>
  )
}

export default StripeConnectSettings
